<template>
  <section class="p-1" aria-labelledby="comment-title" role="form">
    <h2 id="comment-title" class="sr-only">
      {{ $t('field.comment') }}
    </h2>
    <div class="d-flex flex-column noPadding">
      <TextArea
        :label="$t('field.comment')"
        v-model="comment"
        :error="errorMessage"
        :required="false"
        id="comment-textarea"
        :placeholder="$t('placeholder.comment')"
        :max-length="maxLength"
      />
    </div>
    <Button
      icon-left="floppy-disk"
      @click="onCommentSelected"
      class="btn btn-accordion"
      :aria-label="$t('button.commentAdd')"
      :aria-describedby="errorMessage ? 'comment-error' : null"
      :disabled="!!errorMessage"
    >
      <span>{{ $t('button.save') }}</span>
    </Button>
    <Button
      icon-left="close"
      :secondary="true"
      @click="close"
      class="btn btn-accordion"
      :aria-label="$t('button.close')"
    >
      <span>{{ $t('button.close') }}</span>
    </Button>
  </section>
</template>

<script>
import Button from "@/components/barrier-free-template-components/Button.vue";
import TextArea from "@/components/barrier-free-template-components/TextArea.vue";

export default {
  components: {
    TextArea,
    Button,
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      comment: this.value,
      errorMessage: null,
    };
  },
  watch: {
    value(newVal) {
      this.comment = newVal;
    }
  },
  methods: {
    onCommentSelected() {
      if (!this.comment) {
        this.errorMessage = this.$t('notification.commentRequired');
        return;
      }
      this.errorMessage = null;
      this.$emit('input', this.comment); // keep v-model in sync
      this.$emit('comment-selected', this.comment);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';

.btn-accordion {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  width: 100%;
  margin: 5px 0 0;
}
</style>
